import { useCallback } from 'react';

import { getMSALInstance } from '~/services/msal';
import { useSubmit } from '@remix-run/react';
import { useApplicationContext } from '../ApplicationContext';

export function useSignOutWithMsal() {
    const applicationContext = useApplicationContext();
    const submit = useSubmit();
    const handleSignOut = useCallback(async () => {
        const msalClient = getMSALInstance();
        await msalClient.initialize();
        await msalClient.clearCache();
        msalClient.setActiveAccount(null);

        submit(null, {
            method: 'POST',
            action: applicationContext?.isIframe
                ? '/iframe?index'
                : '/office?index',
        });
    }, [submit, applicationContext]);

    return handleSignOut;
}
